// Interprets 429 responses from the AI cover letter endpoints.
//   code 'monthly_ai_limit' -> out of credits for the period (offer an upgrade)
//   code 'rate_limited'     -> hourly limit hit (just wait, no upgrade link)
// Returns null for any other error so callers keep their normal handling.

export const MONTHLY_AI_LIMIT_MESSAGE =
  "You've used all your AI cover letters for this period. You can still write your own cover letter below and apply as usual.";
export const RATE_LIMITED_MESSAGE =
  "You're generating too fast, try again in a few minutes.";

export function parseAiLimitError(err) {
  const res = err && err.response;
  if (!res || res.status !== 429) return null;
  const code = res.data && res.data.code;
  if (code === 'monthly_ai_limit') {
    return {
      code,
      message: MONTHLY_AI_LIMIT_MESSAGE,
      upgradeUrl: (res.data && res.data.upgrade_url) || '/subscription/plans',
    };
  }
  if (code === 'rate_limited') {
    return {
      code,
      message: RATE_LIMITED_MESSAGE,
      upgradeUrl: null,
      retryAfter: (res.data && res.data.retry_after) || null,
    };
  }
  return null;
}
